/* eslint-disable react/prop-types */
import Box from "@material-ui/core/Box";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import i18n from "i18n";
import {
	Button,
	Card,
	CardContent,
	CardHeader,
	Chip,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	InputAdornment,
	InputLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	TextField,
	Tooltip,
	Typography
} from "@material-ui/core";
import { getIntentLabel, replaceInTextHbr } from "./utilities";
import lod_ from "lodash";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { errorMsg } from "redux/reducers/snackMsgsReducers";
import cockpitActions from "../redux/actions/cockpitActions";
import { DataGrid, frFR } from "@material-ui/data-grid";
import parse from "html-react-parser";
import { getMesssageItemSelector } from "redux/selectors/cockpitSelectors";
import { DateTime } from "luxon";

const useStyles = makeStyles(theme => ({
	root: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		marginBottom: "10px",
		marginTop: "10px",
		borderRadius: "15%"
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		display: "flex",
		flexDirection: "row",
		alignItems: "center"
	},
	secondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: "black"
	},
	AccordionDetails: {
		marginBottom: "10px",
		fontSize: theme.typography.pxToRem(15)
	}
}));

const checkType = type => {
	if (!["email", "string", "number", "date", "phone", "boolean"].includes(type)) {
		return false;
	} else {
		return true;
	}
};

export default function ProcessCall({ conversation, assistantConfig }) {
	const classes = useStyles();
	const [openDialog, setOpenDialog] = useState(false);
	const [openDialogPopUp, setOpenDialogPopUp] = useState(false);
	const [callProcess, setCallProcess] = useState({});
	const [listOfCallProcess, setListOfCallProcess] = useState({});
	const [actionDefault, setActionDefault] = useState([]);
	const [argumentMotif, setArgumentMotif] = useState({});
	const [rowSelected, setRowSelected] = useState([]);
	const [rowIndexSelected, setRowIndexSelected] = useState(null);
	const [valueContext, setValueContext] = useState([]);
	const [valueContextPopUp, setValueContextPopUp] = useState([]);
	const [columns, setColumns] = useState([]);
	const [columnsPopUp, setColumnsPopUp] = useState([]);
	const [dictionary, setDictionary] = useState({});
	const [selectedAction, setSelectedAction] = useState({});
	const [reasonRefund, setReasonRefund] = useState(null);
	const [reasonDiscount, setReasonDiscount] = useState(null);
	const [listOfReasons, setListOfReasons] = useState([]);

	const [valuesOfSolutions, setValuesOfSolutions] = useState({});

	const { userStatus } = useSelector(state => state);
	const [language] = useState(userStatus?.auth?.user?.language?.toLowerCase() ?? "fr");
	const answersType = useSelector(state => state.answers.data ?? []);
	const aConfig = useSelector(getMesssageItemSelector, shallowEqual);
	const intents = aConfig?.intents ?? [];
	const [refund, setRefund] = useState(null);
	const [discount, setDiscount] = useState(null);

	const [actionDateSelected, setActionDateSelected] = useState(null);
	const [requiredDate, setRequiredDate] = useState(false);

	const dispatch = useDispatch();

	// BUILD width for column of table
	function getDynamicColumnWidth(field, rows, headerName) {
		const checkLength = headerName.length < field.length ? field.length : headerName.length;

		const maxLength = Math.max(
			...rows.map(row => {
				const value = row[field];
				return value ? value.toString().length : 0;
			}),
			checkLength
		);

		const estimatedWidth = maxLength * 8 + 20;

		return Math.min(Math.max(estimatedWidth, 80), 400);
	}

	/**
	 * Build table path of context and dico
	 * @param {*} dictionary build collumn of table
	 * @param {*} values row of table
	 * @param {*} flex style of table
	 */
	const buildTable = (dictionary, values, flex = false) => {
		let buildColumns = [{ field: "id", headerName: "ID", sortable: false, width: 90, hide: true }];
		Object.keys(dictionary.items)
			.sort((a, b) => dictionary.items[a]?.order - dictionary.items[b]?.order)
			.map((child, key) => {
				if (
					checkType(dictionary.items[child]?.type) &&
					dictionary.items[child]?.active === true &&
					dictionary.items[child]?.display === true
				) {
					const headerName = lod_.isNil(dictionary.items[child]?.label[language])
						? child
						: dictionary.items[child]?.label[language];

					let preBuild = {};

					if (flex === true) {
						preBuild.flex = 1;
					} else {
						preBuild.width = getDynamicColumnWidth(child, values, headerName);
					}

					buildColumns.push({
						...preBuild,
						field: child,
						headerName,
						sortable: true,
						align: "left",
						headerAlign: "left",
						valueFormatter: params => {
							const value = params.value;

							if (child === "billingRemainingAmount") {
								if (lod_.isNil(value)) {
									return "";
								} else {
									return `${value / 100} €`;
								}
							}

							return value;
						},
						renderCell: params => (
							<Tooltip title={params.formattedValue} arrow>
								<span
									style={{
										overflow: "hidden",
										textOverflow: "ellipsis",
										whiteSpace: "nowrap",
										display: "block"
									}}
								>
									{params.formattedValue}
								</span>
							</Tooltip>
						),
						type: dictionary.items[child]?.type
					});
				}
			});
		return buildColumns;
	};

	/**
	 * Use Effect for launch config of call process -> build all process to have correct argument, solution, subs, ....
	 */
	useEffect(() => {
		setArgumentMotif({});
		setCallProcess({});
		setValuesOfSolutions({});
		setValueContext([]);
		setRowSelected([]);
		setRowIndexSelected(null);
		setColumns([]);
		setDictionary({});
		setListOfCallProcess([]);
		setActionDefault([]);
		setReasonRefund(null);
		setReasonDiscount(null);
		setRefund(null);
		setActionDateSelected(null);
		setDiscount(null);
		setRequiredDate(false);
		let channel = assistantConfig?.channels.find(
			c => c.code === conversation?.header?.extra?.channelCode
		);

		if (
			!lod_.isNil(channel) &&
			!lod_.isNil(channel?.callProcess) &&
			!lod_.isEmpty(channel?.callProcess)
		) {
			let processObject = channel.callProcess;

			if (
				!lod_.isNil(processObject?.actionDefault) &&
				!lod_.isEmpty(processObject?.actionDefault)
			) {
				setActionDefault(processObject?.actionDefault);
			} else {
				setActionDefault([]);
			}

			if (
				!lod_.isNil(processObject?.listOfReasons) &&
				!lod_.isEmpty(processObject?.listOfReasons)
			) {
				setListOfReasons(processObject?.listOfReasons);
			} else {
				setListOfReasons([]);
			}

			const onSuccessCallProcess = res => {
				if (!lod_.isNil(res?.payload?.callProcess) && !lod_.isEmpty(res?.payload?.callProcess)) {
					const listProcess = res?.payload?.callProcess;
					let argumentsOfCall = [];
					for (let key in listProcess) {
						const process = { actionsProcess: processObject.actionsProcess };

						const argument = answersType.find(item => item?.code === listProcess[key]?.argument);
						if (!lod_.isNil(argument) && !lod_.isEmpty(argument)) {
							process.argument = argument?.content;
						}

						const solution = answersType.find(item => item?.code === listProcess[key]?.solution);
						if (!lod_.isNil(solution) && !lod_.isEmpty(solution)) {
							process.solution = solution?.content;
						}

						if (
							!lod_.isNil(listProcess[key]?.actionsProcess) &&
							!lod_.isEmpty(listProcess[key]?.actionsProcess) &&
							listProcess[key]?.actionsProcess !== "undefined"
						) {
							process.actionsNextProcess = listProcess[key]?.actionsProcess;
						}

						argumentsOfCall.push(process);
					}
					setListOfCallProcess(argumentsOfCall);
				} else {
					setListOfCallProcess({});
				}
			};

			const onFailureCallProcess = res => {
				dispatch(errorMsg(i18n.t(`COC.actionForm.noCallProcessFound`)));
				setListOfCallProcess({});
			};

			dispatch(
				cockpitActions.getCallProcess(
					{
						assistantID: conversation?.header.assistantID,
						resource: processObject?.resource,
						topic: conversation?.meta?.topic,
						brand: conversation?.context.brand,
						mapping: processObject?.mapping
					},
					onSuccessCallProcess,
					onFailureCallProcess
				)
			);

			if (!lod_.isNil(processObject?.actionsProcess?.pathDictionary)) {
				let values = lod_.get(conversation, processObject?.actionsProcess?.pathDictionary);

				if (!lod_.isNil(values) && lod_.isArray(values)) {
					setValueContext(values);
				} else {
					setValueContext([]);
				}
			} else {
				setValueContext([]);
			}

			const onSuccess = res => {
				if (!lod_.isNil(res?.payload?.dictionary) && !lod_.isEmpty(res?.payload?.dictionary)) {
					setDictionary(res.payload.dictionary);
					let values = lod_.get(conversation, processObject?.actionsProcess?.pathDictionary) || [];
					const resultColumns = buildTable(res.payload.dictionary, values);
					setColumns(resultColumns);
				} else {
					setDictionary({});
				}
			};

			const onFailure = res => {
				dispatch(errorMsg(i18n.t(`COC.actionForm.noDicoFoundAction`)));
				setDictionary({});
			};

			dispatch(
				cockpitActions.getDictionnaryByCode(
					{
						assistantID: conversation?.header.assistantID,
						codeDictionary: processObject?.actionsProcess?.codeDictionary
					},
					onSuccess,
					onFailure
				)
			);
		} else {
			setCallProcess({});
			setValuesOfSolutions({});
		}
	}, [conversation?.meta?.topic, conversation?.header?.fID]);

	/**
	 * Build label of solution for review process
	 * @param {*} data
	 * @param {*} attachment
	 */
	const buildSolutionReview = (solutionValue, process) => {
		let result = {};

		const listOfActions = callProcess?.actionsNextProcess;

		// BUILD LABEL OF SOLUTION
		if (!lod_.isNil(solutionValue) && !lod_.isNil(process) && !lod_.isNil(process?.menu?.choices)) {
			const foundItem = process.menu.choices.find(action => action.value === solutionValue);

			if (!lod_.isNil(foundItem) && !lod_.isEmpty(foundItem)) {
				result.label = `${foundItem?.label}`;
			} else {
				result.label = `${i18n.t("COC.noSolutions")}`;
			}
		} else {
			result.label = `${i18n.t("COC.noSolutions")}`;
		}

		// BUILD CONFIG
		let channel = assistantConfig?.channels.find(
			c => c.code === conversation?.header?.extra?.channelCode
		);

		if (
			!lod_.isNil(listOfActions) &&
			!lod_.isEmpty(listOfActions) &&
			!lod_.isNil(channel?.callProcess?.notIncludedActions)
		) {
			const foundItem = listOfActions.find(action => action?.value === solutionValue);

			if (!lod_.isNil(foundItem?.action)) {
				result.action = foundItem.action;
			}
			if (foundItem && channel?.callProcess?.notIncludedActions.includes(foundItem?.action)) {
				result.include = false;
			} else if (!lod_.isNil(foundItem)) {
				result.include = true;
			} else {
				result.include = false;
			}
		} else {
			result.include = false;
		}

		return result;
	};

	/**
	 * Change value of solution
	 * @param {*} value of choice
	 * @param {*} index of choice
	 */
	const handleChange = (value, index) => {
		setValuesOfSolutions(prev => {
			let solutions = lod_.cloneDeep(prev);
			solutions[index] = value;
			return solutions;
		});
		setCallProcess(prev => {
			let cloneProcess = lod_.cloneDeep(prev);
			cloneProcess.solution[index].value = value;
			return cloneProcess;
		});
	};

	/**
	 * LAUNCH specific action from call Process to action frontV2 callProcess
	 */
	const launchCallProcess = () => {
		/**
		 * PIKA : 2025.08.16 - Labels and Values must be equal in listOfreasons. Unless better solution
		 */
		let reasonDiscountText = lod_.isNil(reasonDiscount) ? "" : i18n.t(`COC.${reasonDiscount}`);
		dispatch(
			cockpitActions.launchActionFrontV2("callProcess", {
				header: {
					assistantID: conversation.header.assistantID,
					fID: conversation.header.fID
				},
				payload: {
					rowSelected,
					argument: argumentMotif,
					solution: callProcess?.solution,
					actionsProcess: callProcess?.actionsNextProcess,
					contact: conversation.contact,
					refund,
					reasonRefund,
					discount,
					reasonDiscount,
					reasonDiscountText,
					actionDateSelected
				}
			})
		);
		setOpenDialog(false);
	};

	/**
	 * Launch default action from config and execute specific type of action
	 */
	const launchActionDefault = process => {
		const type = process?.type;
		const mappingIN = process?.mapping?.in;
		const codeDictionary = process?.config?.codeDictionary;
		const pathDictionary = process?.config?.pathDictionary;
		setSelectedAction(process);

		switch (type) {
			case "url": {
				if (!lod_.isNil(mappingIN) && !lod_.isEmpty(mappingIN)) {
					let URLMapped = replaceInTextHbr(
						mappingIN,
						{ conversation, user: userStatus?.auth?.user, rowSelected: rowSelected[0] },
						false
					);
					if (!lod_.isNil(URLMapped) && !lod_.isEmpty(URLMapped)) {
						window.open(URLMapped, "_blank");
					}
				}
				break;
			}
			case "popUpMatch": {
				if (!lod_.isNil(pathDictionary)) {
					let values = lod_.get(conversation, pathDictionary);

					if (!lod_.isNil(values) && lod_.isArray(values)) {
						if (!lod_.isNil(rowSelected) && !lod_.isEmpty(rowSelected)) {
							const arrayFiltred = values.filter(item2 =>
								rowSelected.some(item1 => item1.name === item2.subscriptionName)
							);
							setValueContextPopUp(arrayFiltred);
						} else {
							setValueContextPopUp(values);
						}
					} else {
						setValueContextPopUp([]);
					}
				} else {
					setValueContextPopUp([]);
				}

				const onSuccess = res => {
					if (!lod_.isNil(res?.payload?.dictionary) && !lod_.isEmpty(res?.payload?.dictionary)) {
						let values = lod_.get(conversation, pathDictionary) || [];
						const resultColumns = buildTable(res.payload.dictionary, values, true);
						setColumnsPopUp(resultColumns);
						setOpenDialogPopUp(true);
					} else {
						setOpenDialogPopUp(false);
					}
				};

				const onFailure = res => {
					dispatch(errorMsg(i18n.t(`COC.actionForm.noDicoFoundAction`)));
				};
				dispatch(
					cockpitActions.getDictionnaryByCode(
						{
							assistantID: conversation?.header.assistantID,
							codeDictionary
						},
						onSuccess,
						onFailure
					)
				);
				break;
			}
			default:
				break;
		}
	};

	/**
	 * Close dialog show resume of process
	 */
	const handleClose = () => {
		setOpenDialog(false);
		// setRequiredDate(false);
	};

	/**
	 * Close dialog show pop up action
	 */
	const handleClosePopUp = () => {
		setOpenDialogPopUp(false);
		setValueContextPopUp([]);
	};

	/**
	 * Select Argument and set solution of this argument
	 * @param {*} data
	 * @param {*} attachment
	 */
	const choiceArgument = (configProcess, argument) => {
		setArgumentMotif(argument);
		setCallProcess(prev => {
			let cloneProcess = lod_.cloneDeep(prev);
			cloneProcess.solution = configProcess?.solution;
			cloneProcess.actionsProcess = configProcess?.actionsProcess;
			cloneProcess.actionsNextProcess = configProcess?.actionsNextProcess;
			return cloneProcess;
		});
	};

	/**
	 * Build Chip of motif and argument
	 * @param {*} data
	 * @param {*} attachment
	 */
	const buildArgument = argumentsCall => {
		return (
			<Box style={{ display: "flex", flexWrap: "wrap" }}>
				{argumentsCall?.argument.map((process, key) => (
					<Box key={key} pr={1} pb={1}>
						<Chip
							style={{ marginRight: "1%" }}
							label={process[language.toUpperCase()]?.subject}
							color={
								argumentMotif?.subject === process[language.toUpperCase()].subject
									? "primary"
									: "default"
							}
							clickable={true}
							onClick={() => choiceArgument(argumentsCall, process[language.toUpperCase()])}
						/>
					</Box>
				))}
			</Box>
		);
	};

	/**
	 * Build overview of solution for review style
	 * @param {*} action
	 */
	const buildSolutionOverview = (action, review = false) => {
		switch (action) {
			case "offerDiscountSubscription": {
				return (
					<Box
						style={{
							display: "flex",
							flexDirection: "row",
							marginBottom: "2%",
							marginTop: "1%",
							width: "100%"
						}}
					>
						<TextField
							type="number"
							style={{ paddingRight: "2%" }}
							label={i18n.t("COC.fieldAmmount")}
							variant="outlined"
							fullWidth
							value={discount}
							InputProps={{
								inputProps: { step: "1" },

								readOnly: review
							}}
							onChange={e => {
								const value = e.target.valueAsNumber;
								setDiscount(value < 0 ? 0 : value);
							}}
						/>

						<FormControl fullWidth variant="outlined">
							<InputLabel id="demo-simple-select-label">{i18n.t("COC.reasonChoice")}</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={reasonDiscount}
								disabled={review}
								label={i18n.t("COC.reasonChoice")}
								onChange={e => setReasonDiscount(e.target.value)}
							>
								{listOfReasons
									.filter(item => lod_.isNil(item?.type) || item?.type === "discount")
									.sort((a, b) =>
										i18n.t(`COC.${a?.label}`).localeCompare(i18n.t(`COC.${b?.label}`))
									)
									.map((code, index) => (
										<MenuItem key={index} value={code.value}>
											{i18n.t(`COC.${code.label}`)}
										</MenuItem>
									))}
							</Select>
						</FormControl>
					</Box>
				);
			}

			case "refundAmount":
			case "offerDiscountSubscription50":
			case "refundSubscription":
			case "cancelAndPartialRefundSubscription":
			case "cancelAndRefundSubscription": {
				return (
					<Box
						style={{
							display: "flex",
							flexDirection: "row",
							marginBottom: "2%",
							marginTop: "1%",
							width: "100%"
						}}
					>
						<TextField
							type="number"
							style={{ paddingRight: "2%" }}
							label={i18n.t("COC.fieldAmmount")}
							variant="outlined"
							InputLabelProps={{ shrink: true }}
							fullWidth
							value={refund}
							InputProps={{
								inputProps: { step: "1" },
								readOnly: review
							}}
							onChange={e => {
								const value = e.target.valueAsNumber;

								// Arrondi pour supprimer la ","
								const result = Math.round(value);

								setRefund(result < 0 ? 0 : result);
							}}
						/>

						<FormControl fullWidth variant="outlined">
							<InputLabel id="demo-simple-select-label">{i18n.t("COC.reasonChoice")}</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={reasonRefund}
								disabled={review}
								label={i18n.t("COC.reasonChoice")}
								onChange={e => setReasonRefund(e.target.value)}
							>
								{listOfReasons
									.filter(item => lod_.isNil(item?.type) || item?.type === "refund")
									.sort((a, b) => a?.label.localeCompare(b?.label))
									.map((code, index) => (
										<MenuItem key={index} value={code.value}>
											{code.value === null ? i18n.t(`COC.${code.label}`) : code.label}
										</MenuItem>
									))}
							</Select>
						</FormControl>
					</Box>
				);
			}
			case "suspendSubscription":
			case "resumeSubscription": {
				return (
					<Box
						style={{
							width: "50%",
							marginBottom: "1%",
							marginTop: "1%"
						}}
					>
						<SelectDateAction
							actionDateSelected={actionDateSelected}
							handleChangeSupsendDate={handleChangeSupsendDate}
							subscription={rowSelected}
							isReview={review}
						/>
					</Box>
				);
			}
			default: {
				return <></>;
			}
		}
	};

	/**
	 * Build Chip of solution for review style
	 * @param {*} process
	 */
	const buildSolutionChipReview = process => {
		const solution = buildSolutionReview(process?.value, process[language.toUpperCase()]);

		return (
			<>
				<Chip
					style={{ backgroundColor: solution?.include === false ? "red" : "" }}
					label={solution?.label}
					color={"primary"}
					clickable={false}
				/>
				{!lod_.isNil(solution?.action) && buildSolutionOverview(solution?.action, true)}
			</>
		);
	};
	/**
	 * Check if OK to launch call process
	 */
	const checkSolutions = () => {
		if (lod_.isNil(callProcess?.solution) || lod_.isEmpty(callProcess?.solution)) {
			return;
		}

		let result = false;

		callProcess?.solution.forEach(process => {
			if (process?.value) {
				const solution = buildSolutionReview(process?.value, process[language.toUpperCase()]);

				if (
					!lod_.isNil(solution) &&
					!lod_.isNil(solution?.action) &&
					(solution?.action === "suspendSubscription" ||
						solution?.action === "resumeSubscription") &&
					lod_.isNil(actionDateSelected)
				) {
					// CHECK
					result = true;
				}
			}
		});

		setRequiredDate(result);
	};

	/**
	 * Check if OK to launch call process check date and row of subs
	 * @returns {boolean}
	 */
	const checkDisabledValidateReview = () => {
		if (lod_.isEmpty(rowSelected)) {
			return true;
		}

		if (requiredDate === true) {
			return true;
		}

		return false;
	};

	/**
	 * Check if solution required are filled
	 * @returns {boolean}
	 */
	const checkRequired = () => {
		if (!lod_.isNil(callProcess?.solution) && !lod_.isEmpty(callProcess?.solution)) {
			const hasRequiredWithoutValue = callProcess.solution.some(process => {
				const isRequired = process[language.toUpperCase()]?.menu?.isRequired;
				return isRequired === true && lod_.isNil(process?.value);
			});
			if (hasRequiredWithoutValue) {
				return true;
			}
		}

		return false;
	};

	/**
	 * Check all validate condtion and return disabled or not
	 * @returns {boolean}
	 */
	const checkDisabledValidate = () => {
		const requiredMissing = checkRequired();

		if (requiredMissing) {
			return true;
		}

		// FOR OTHER CHECK ...

		return false;
	};

	/**
	 * Set suspend date
	 * @param {*} value
	 */
	const handleChangeSupsendDate = value => {
		setActionDateSelected(value);
	};

	/**
	 * Return an error message with specific message for error
	 */
	const checkErrorMessage = () => {
		if (lod_.isEmpty(rowSelected)) {
			return <Box style={{ color: "red" }}>{i18n.t("COC.emptyRowSub")}</Box>;
		}

		if (requiredDate === true) {
			return <Box style={{ color: "red" }}>{i18n.t("COC.emptyActionDateSelected")}</Box>;
		}

		return <></>;
	};

	/**
	 * Return an action for action selected for process
	 */
	const checkSolutionAction = (process, index) => {
		const solution = buildSolutionReview(valuesOfSolutions[index], process[language.toUpperCase()]);
		if (!lod_.isNil(solution) && !lod_.isNil(solution?.action)) {
			switch (solution.action) {
				case "newSubscription": {
					return (
						<Box>
							{!lod_.isNil(actionDefault) &&
								!lod_.isEmpty(actionDefault) &&
								actionDefault
									.filter(action => {
										return (
											!lod_.isNil(action?.needSolutions) &&
											!lod_.isEmpty(action?.needSolutions) &&
											action?.needSolutions.includes(solution?.action)
										);
									})
									.map((process, key) => (
										<Button
											key={key}
											style={{ marginTop: "2%", marginRight: "1%" }}
											color="primary"
											disabled={
												process?.needRowSelected === true && lod_.isEmpty(rowSelected)
													? true
													: false
											}
											variant="contained"
											onClick={() => launchActionDefault(process)}
										>
											{process?.title}
										</Button>
									))}
						</Box>
					);
				}

				default: {
					return buildSolutionOverview(solution?.action, false);
				}
			}
		}
		return <></>;
	};

	/**
	 * Check action refund
	 */
	const checkRefundAction = () => {
		const refundActions = new Set([
			"refundAmount",
			"offerDiscountSubscription50",
			"cancelAndPartialRefundSubscription",
			"cancelAndRefundSubscription",
			"refundSubscription"
		]);

		if (
			lod_.isNil(callProcess) ||
			lod_.isNil(callProcess?.solution) ||
			lod_.isEmpty(callProcess?.solution)
		) {
			setRefund(null);
			setReasonRefund(null);
			return;
		}

		const listOfActions = callProcess?.actionsNextProcess ?? [];

		const anyRefundSelected = callProcess.solution.some(proc => {
			const val = proc?.value;
			if (lod_.isNil(val)) return false;
			const found = Array.isArray(listOfActions) ? listOfActions.find(a => a?.value === val) : null;
			const action = found?.action;
			return refundActions.has(action);
		});

		if (!anyRefundSelected) {
			setRefund(null);
			setReasonRefund(null);
			return;
		}

		if (!lod_.isNil(refund)) {
			return;
		}

		if (!lod_.isNil(rowSelected) && !lod_.isEmpty(rowSelected)) {
			const subscription = rowSelected[0];
			if (!lod_.isNil(subscription) && !lod_.isNil(subscription?.billingRemainingAmount)) {
				const refundAmount =
					typeof subscription?.billingRemainingAmount === "number" &&
					Number.isFinite(subscription?.billingRemainingAmount)
						? subscription?.billingRemainingAmount / 100
						: null;
				setRefund(refundAmount);
			} else {
				setRefund(0);
			}
		}
	};

	/**
	 * Check action discount
	 */
	const checkDiscountAction = () => {
		const discountActions = new Set(["offerDiscountSubscription"]);

		if (
			lod_.isNil(callProcess) ||
			lod_.isNil(callProcess?.solution) ||
			lod_.isEmpty(callProcess?.solution)
		) {
			setDiscount(null);
			setReasonDiscount(null);
			return;
		}

		const listOfActions = callProcess?.actionsNextProcess ?? [];

		const anyDiscountSelected = callProcess.solution.some(proc => {
			const val = proc?.value;
			if (lod_.isNil(val)) return false;
			const found = Array.isArray(listOfActions) ? listOfActions.find(a => a?.value === val) : null;
			const action = found?.action;
			return discountActions.has(action);
		});

		if (!anyDiscountSelected) {
			setDiscount(null);
			setReasonDiscount(null);
			return;
		}
	};

	/**
	 * When callProcess solutions change, ensure `refund` is null unless
	 * one of the selected solutions requires a refund-type action.
	 *
	 */
	useEffect(() => {
		checkRefundAction();
		checkDiscountAction();
	}, [callProcess?.solution, callProcess?.actionsNextProcess]);

	/**
	 * When callProcess context change, update the table data (valueContext)
	 * and rebuild columns if necessary. Also reset selection/date.
	 */
	useEffect(() => {
		// Determine the path to the dictionary values from the channel config
		let channel = assistantConfig?.channels.find(
			c => c.code === conversation?.header?.extra?.channelCode
		);
		const pathDictionary = channel?.callProcess?.actionsProcess?.pathDictionary;
		if (pathDictionary) {
			let newValuesContext = lod_.get(conversation, pathDictionary);

			if (!lod_.isNil(newValuesContext) && lod_.isArray(newValuesContext)) {
				setValueContext(newValuesContext);
			} else {
				setValueContext([]);
			}

			if (
				!lod_.isNil(rowIndexSelected) &&
				!lod_.isNil(newValuesContext) &&
				lod_.isArray(newValuesContext)
			) {
				const latestSelection = Array.isArray(rowIndexSelected)
					? [rowIndexSelected[rowIndexSelected.length - 1]]
					: [rowIndexSelected];
				const selectedValues = newValuesContext.filter((value, index) => {
					const generatedId = value?.id ?? index + 1;
					return latestSelection.includes(generatedId);
				});
				setRowSelected(selectedValues);
			} else {
				setRowSelected([]);
			}
		}
	}, [conversation?.context, conversation?.header?.extra?.channelCode, dictionary]);

	return (
		<>
			{!lod_.isNil(listOfCallProcess) && !lod_.isEmpty(listOfCallProcess) ? (
				<Box style={{ padding: "5px" }}>
					<Card>
						<CardHeader
							style={{ paddingBottom: "1px" }}
							avatar={<LibraryBooksIcon />}
							title={`${i18n.t("COC.convCallProcess")} pour ${getIntentLabel(conversation?.meta?.topic, intents)}`}
						/>

						<CardContent className={classes.AccordionDetails}>
							{!lod_.isNil(listOfCallProcess) && !lod_.isEmpty(listOfCallProcess) ? (
								<Box style={{ display: "flex", flexDirection: "column" }}>
									<Box style={{ marginBottom: "2%" }}>
										<Accordion className="classAccordeonTabInfo">
											<AccordionSummary
												expandIcon={<ExpandMoreIcon />}
												aria-controls="panel1a-content"
												id="panel1a-header"
											>
												<Typography variant="h6">{i18n.t("COC.arguments")} : </Typography>
											</AccordionSummary>
											<AccordionDetails>
												{/* BUILD LIST OF ARGUMENT CHOICE */}
												<Box style={{ padding: "1%" }}>
													<Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
														Motif :
													</Typography>
													<span
														style={{
															marginTop: "1%",
															marginBottom: "2%",
															display: "flex",
															flexWrap: "wrap",
															width: "100%"
														}}
													>
														{listOfCallProcess.map((process, key) => (
															<Box key={key}>{buildArgument(process)}</Box>
														))}
													</span>
													{!lod_.isNil(argumentMotif) && !lod_.isEmpty(argumentMotif) && (
														<Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
															{parse(`${argumentMotif?.text}`)}
														</Typography>
													)}
												</Box>
											</AccordionDetails>
										</Accordion>
									</Box>

									{/* BUILD LIST OF SUBS CHOICE */}
									{!lod_.isNil(callProcess?.actionsProcess) &&
										!lod_.isNil(valueContext) &&
										!lod_.isEmpty(valueContext) &&
										!lod_.isNil(dictionary?.items) &&
										!lod_.isEmpty(dictionary?.items) && (
											<Box style={{ marginBottom: "2%" }}>
												<Accordion className="classAccordeonTabInfo">
													<AccordionSummary
														expandIcon={<ExpandMoreIcon />}
														aria-controls="panel1a-content"
														id="panel1a-header"
													>
														<Typography variant="h6">{i18n.t("COC.subscription")} :</Typography>
													</AccordionSummary>
													<AccordionDetails>
														<Typography style={{ paddingLeft: "1%" }}>
															{callProcess?.actionsProcess?.title}
														</Typography>
														<Box style={{ padding: "1%" }}>
															<Box style={{ maxHeight: 400, maxWidth: "100%", overflow: "auto" }}>
																<DataGrid
																	rows={valueContext.map((value, index) => ({
																		id: value?.id ?? index + 1,
																		...value
																	}))}
																	columns={columns}
																	autoHeight
																	disableColumnFilter
																	hideFooter
																	hideFooterRowCount
																	checkboxSelection={false}
																	hideFooterSelectedRowCount
																	onSelectionModelChange={selection => {
																		// Prend uniquement le dernier élément sélectionné
																		const latestSelection = Array.isArray(selection)
																			? [selection[selection.length - 1]]
																			: [selection];

																		const selectedValues = valueContext.filter((value, index) => {
																			const generatedId = value?.id ?? index + 1;
																			return latestSelection.includes(generatedId);
																		});

																		setRowIndexSelected(selection);
																		setRowSelected(selectedValues);
																		setActionDateSelected(null);
																	}}
																	localeText={frFR.props.MuiDataGrid.localeText}
																/>
															</Box>
														</Box>
													</AccordionDetails>
												</Accordion>
											</Box>
										)}

									{/* BUILD LIST OF SOLUTION CHOICE */}
									{!lod_.isNil(callProcess?.solution) && !lod_.isEmpty(callProcess?.solution) && (
										<Box style={{ marginBottom: "2%" }}>
											<Accordion className="classAccordeonTabInfo">
												<AccordionSummary
													expandIcon={<ExpandMoreIcon />}
													aria-controls="panel1a-content"
													id="panel1a-header"
												>
													<Typography variant="h6">{i18n.t("COC.solutions")} : </Typography>
												</AccordionSummary>
												<AccordionDetails>
													<Box style={{ padding: "1%" }}>
														{callProcess.solution.map((process, key) => (
															<Box key={key} style={{ display: "flex", flexDirection: "column" }}>
																<Typography variant="body1">
																	{key + 1} -{" "}
																	{!lod_.isNil(process[language.toUpperCase()]?.menu?.subject)
																		? process[language.toUpperCase()]?.menu?.subject
																		: ""}
																</Typography>
																<FormControl component="fieldset">
																	<RadioGroup
																		row
																		aria-label="gender"
																		name="gender1"
																		value={process.value ?? null}
																		onChange={e => handleChange(e.target.value, key)}
																	>
																		{!lod_.isNil(process[language.toUpperCase()]?.menu?.choices) &&
																			!lod_.isEmpty(
																				process[language.toUpperCase()]?.menu?.choices
																			) &&
																			process[language.toUpperCase()]?.menu?.choices.map(
																				(choice, key) => (
																					<Box
																						key={key}
																						style={{
																							display: "flex",
																							flexDirection: "row",
																							alignItems: "center"
																						}}
																					>
																						<FormControlLabel
																							value={choice?.value}
																							control={<Radio />}
																							label={choice?.label}
																						/>
																					</Box>
																				)
																			)}
																	</RadioGroup>
																</FormControl>
																{checkSolutionAction(process, key)}
																{/* Check if menu is required and perform to check if the value is not null */}
																{process[language.toUpperCase()]?.menu?.isRequired === true &&
																	lod_.isNil(process?.value) && (
																		<Box style={{ color: "red", marginBottom: "8px" }}>
																			{i18n.t("COC.requiredSolutionMissing")}
																		</Box>
																	)}
															</Box>
														))}
														{/* <Typography variant="body1">
															{callProcess?.solution.length + 1} - {i18n.t("COC.refundProcess")}
														</Typography>

														<Box
															style={{
																display: "flex",
																flexDirection: "row",
																marginBottom: "2%",
																marginTop: "1%",
																width: "100%"
															}}
														>
															<TextField
																type="number"
																style={{ paddingRight: "2%" }}
																label={i18n.t("COC.fieldAmmount")}
																variant="outlined"
																fullWidth
																value={refund}
																InputProps={{
																	inputProps: { step: "1" }
																}}
																onChange={e => {
																	const value = e.target.valueAsNumber;
																	setRefund(value < 0 ? 0 : value);
																}}
															/>

															<FormControl fullWidth variant="outlined">
																<InputLabel id="demo-simple-select-label">
																	{i18n.t("COC.reasonChoice")}
																</InputLabel>
																<Select
																	labelId="demo-simple-select-label"
																	id="demo-simple-select"
																	value={reasonRefund}
																	label={i18n.t("COC.reasonChoice")}
																	onChange={e => setReasonRefund(e.target.value)}
																>
																	{listOfReasons
																		.filter(
																			item => lod_.isNil(item?.type) || item?.type === "refund"
																		)
																		.sort((a, b) =>
																			i18n
																				.t(`COC.${a?.label}`)
																				.localeCompare(i18n.t(`COC.${b?.label}`))
																		)
																		.map((code, index) => (
																			<MenuItem key={index} value={code.value}>
																				{i18n.t(`COC.${code.label}`)}
																			</MenuItem>
																		))}
																</Select>
															</FormControl>
														</Box> */}

														<Box style={{ display: "flex", flexDirection: "column" }}>
															<Button
																style={{ marginTop: "1%" }}
																color="primary"
																variant="contained"
																id="formatted-numberformat-input"
																disabled={checkDisabledValidate()}
																onClick={() => {
																	setOpenDialog(true);
																	checkSolutions();
																}}
															>
																{i18n.t("COC.validate")}
															</Button>
														</Box>
													</Box>
												</AccordionDetails>
											</Accordion>
										</Box>
									)}
									<Box>
										{!lod_.isNil(actionDefault) &&
											!lod_.isEmpty(actionDefault) &&
											actionDefault
												.filter(action => {
													return (
														lod_.isNil(action?.needSolutions) || lod_.isEmpty(action?.needSolutions)
													);
												})
												.map((process, key) => (
													<Button
														key={key}
														style={{ marginTop: "2%", marginRight: "1%" }}
														color="primary"
														disabled={
															process?.needRowSelected === true && lod_.isEmpty(rowSelected)
																? true
																: false
														}
														variant="contained"
														onClick={() => launchActionDefault(process)}
													>
														{process?.title}
													</Button>
												))}
									</Box>
								</Box>
							) : (
								<Typography>{i18n.t("COC.emptyCallProcess")}</Typography>
							)}
						</CardContent>
					</Card>

					{/* DIALOG CALL PROCESS REVIEW */}
					{openDialog === true && (
						<Dialog
							open={openDialog}
							fullWidth
							maxWidth="lg"
							onClose={handleClose}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description"
						>
							<DialogTitle id="alert-dialog-title">{i18n.t("COC.resumeCallProcess")}</DialogTitle>
							<DialogContent>
								<Box>
									{/* BUILD ARGUMENT REVIEW */}
									{!lod_.isNil(argumentMotif) && !lod_.isEmpty(argumentMotif) && (
										<Box pb={2}>
											<Typography variant="h6">{i18n.t("COC.argument")} :</Typography>
											<Box>
												<Chip label={argumentMotif?.subject} color={"primary"} clickable={false} />
											</Box>
										</Box>
									)}

									{/* BUILD LIST OF SUBS REVIEW */}
									<Box pb={2}>
										<Typography variant="h6">{i18n.t("COC.subscription")} :</Typography>
										{!lod_.isNil(rowSelected) &&
										!lod_.isNil(valueContext) &&
										!lod_.isEmpty(rowSelected) ? (
											<Box>
												<DataGrid
													rows={rowSelected.map((value, index) => ({
														id: value?.id ?? index + 1,
														...value
													}))}
													columns={columns}
													autoHeight
													disableColumnFilter
													hideFooter
													checkboxSelection={false}
													disableSelectionOnClick
													hideFooterRowCount
													hideFooterSelectedRowCount
													localeText={frFR.props.MuiDataGrid.localeText}
												/>
											</Box>
										) : (
											<Box>{i18n.t("COC.emptySubscription")} </Box>
										)}
									</Box>

									{/* BUILD LIST OF SOLUTIONS REVIEW */}
									{!lod_.isNil(callProcess?.solution) && (
										<Box pb={1}>
											<Typography variant="h6">{i18n.t("COC.solutions")} :</Typography>
											{callProcess.solution.map((process, key) => (
												<Box key={key} pb={1}>
													<Typography variant="body1">
														{key + 1} -{" "}
														{!lod_.isNil(process[language.toUpperCase()]?.menu?.subject)
															? process[language.toUpperCase()]?.menu?.subject
															: ""}
													</Typography>
													<Box>{buildSolutionChipReview(process)}</Box>
												</Box>
											))}
											{/* <Typography variant="body1">
												{callProcess?.solution.length + 1} - {i18n.t("COC.refundProcess")}
											</Typography>

											<Box
												style={{
													display: "flex",
													flexDirection: "row",
													marginBottom: "2%",
													marginTop: "1%",
													width: "100%"
												}}
											>
												<TextField
													type="number"
													style={{ paddingRight: "2%" }}
													label={i18n.t("COC.fieldAmmount")}
													variant="outlined"
													fullWidth
													value={refund}
													InputProps={{
														inputProps: { step: "1" },
														readOnly: true
													}}
													onChange={e => {
														const value = e.target.valueAsNumber;
														setReasonRefund(value < 0 ? 0 : value);
													}}
												/>

												<FormControl fullWidth variant="outlined">
													<InputLabel id="demo-simple-select-label">
														{i18n.t("COC.reasonChoice")}
													</InputLabel>
													<Select
														labelId="demo-simple-select-label"
														id="demo-simple-select"
														value={reasonRefund}
														disabled
														label={i18n.t("COC.reasonChoice")}
														onChange={e => {
															setReasonRefund(e.target.value);
														}}
													>
														{listOfReasons
															.filter(item => lod_.isNil(item?.type) || item?.type === "refund")
															.sort((a, b) =>
																i18n.t(`COC.${a?.label}`).localeCompare(i18n.t(`COC.${b?.label}`))
															)
															.map((code, index) => (
																<MenuItem key={index} value={code.value}>
																	{i18n.t(`COC.${code.label}`)}
																</MenuItem>
															))}
													</Select>
												</FormControl>
											</Box> */}
										</Box>
									)}
								</Box>
							</DialogContent>
							<DialogActions>
								{checkErrorMessage()}

								<Button onClick={handleClose} color="secondary">
									{i18n.t("COC.cancel")}
								</Button>
								<Button
									color="primary"
									variant="contained"
									disabled={checkDisabledValidateReview()}
									onClick={() => launchCallProcess()}
								>
									{i18n.t("COC.validate")}
								</Button>
							</DialogActions>
						</Dialog>
					)}
					{/* DIALOG CALL PROCESS ACTION POP-UP */}
					{openDialogPopUp === true && (
						<Dialog
							open={openDialogPopUp}
							fullWidth
							maxWidth="lg"
							onClose={handleClosePopUp}
							aria-labelledby="alert-dialog-title"
							aria-describedby="alert-dialog-description"
						>
							<DialogTitle id="alert-dialog-title">{selectedAction?.title}</DialogTitle>
							<DialogContent>
								{/* BUILD LIST ARRAY */}
								<Box>
									{!lod_.isNil(valueContextPopUp) && !lod_.isEmpty(valueContextPopUp) ? (
										<Box>
											<DataGrid
												rows={valueContextPopUp.map((value, index) => ({
													id: value?.id ?? index + 1,
													...value
												}))}
												columns={columnsPopUp}
												autoHeight
												disableColumnFilter
												hideFooter
												checkboxSelection={false}
												disableSelectionOnClick
												hideFooterRowCount
												hideFooterSelectedRowCount
												localeText={frFR.props.MuiDataGrid.localeText}
											/>
										</Box>
									) : (
										<Box>{i18n.t("COC.emptySubscription")} </Box>
									)}
								</Box>
							</DialogContent>
							<DialogActions>
								<Button onClick={handleClosePopUp} color="secondary">
									{i18n.t("COC.cancel")}
								</Button>
							</DialogActions>
						</Dialog>
					)}
				</Box>
			) : (
				<></>
			)}
		</>
	);
}

function SelectDateAction({ subscription, handleChangeSupsendDate, actionDateSelected, isReview }) {
	/**
	 * Return list of 12 dates before to day (one year)
	 * @param {*} date date to keep day for list of 12 dates
	 *
	 */
	function generateNext12Months(date) {
		// Convertit la date donnée (ex: "31.10.2025")
		const refDate = DateTime.fromFormat(date, "dd.MM.yyyy");
		const refDay = refDate.day;

		// On démarre à partir de la date de référence, pas d'aujourd'hui
		const startDate = refDate;
		const dates = [];

		for (let i = 1; i <= 12; i++) {
			const base = startDate.plus({ months: i });
			// Ajuste le jour pour éviter le débordement (ex: 31 février)
			const day = Math.min(refDay, base.daysInMonth);
			const next = base.set({ day });
			dates.push(next.toFormat("dd.MM.yyyy"));
		}

		return dates;
	}

	/**
	 * Build list of dates in select box
	 * @param {*} subscriptionDate
	 */
	const buildSelectItem = subscriptionDate => {
		const regex = /^\d{2}\.\d{2}\.\d{4}$/;
		if (
			lod_.isNil(subscriptionDate?.currentContractPeriodEnd) ||
			typeof subscriptionDate?.currentContractPeriodEnd !== "string" ||
			!regex.test(subscriptionDate?.currentContractPeriodEnd)
		) {
			return (
				<Chip
					label={i18n.t("COC.invalidDateSubscription")}
					style={{ backgroundColor: "red" }}
					color={"primary"}
					clickable={false}
				/>
			);
		}

		let listOfResumeDate = generateNext12Months(subscriptionDate?.currentContractPeriodEnd);

		if (lod_.isNil(listOfResumeDate)) {
			return (
				<Chip
					label={i18n.t("COC.invalidDateSubscription")}
					style={{ backgroundColor: "red" }}
					color={"primary"}
					clickable={false}
				/>
			);
		}

		return (
			<FormControl fullWidth variant="outlined">
				<InputLabel id="demo-simple-select-label">Date</InputLabel>
				<Select
					labelId="demo-simple-select-label"
					id="demo-simple-select"
					value={actionDateSelected}
					disabled={isReview}
					label={"Date"}
					onChange={e => handleChangeSupsendDate(e.target.value)}
				>
					{listOfResumeDate.map((date, index) => (
						<MenuItem key={index} value={date}>
							{date}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		);
	};

	return (
		<Box>
			{!lod_.isNil(subscription) && !lod_.isEmpty(subscription) ? (
				<Box>
					{/* BUILD LIST ARRAY */}
					{buildSelectItem(subscription[0])}
				</Box>
			) : (
				<Box>
					<Chip
						label={i18n.t("COC.emptySubscription")}
						style={{ backgroundColor: "red" }}
						color={"primary"}
						clickable={false}
					/>
				</Box>
			)}
		</Box>
	);
}
